import { FC, MouseEvent } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

interface HeaderProps {
  onStopSimulation: (event: MouseEvent) => void;
};

const Header: FC<HeaderProps> = ({ onStopSimulation }: HeaderProps) => {
    const classes = useStyles();

    return (
      <div className={classes.root}>
        <Button
          className={classes.closeButton}
          variant="contained"
          onClick={(e) => onStopSimulation(e)}>
          Cerrar
        </Button>
      </div>
    );
};

Header.defaultProps = { };

export default Header;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: "25px 32px 15px 32px",
    backgroundColor: "#655a50",
    display: "flex",
    justifyContent: "flex-end",
  },
  closeButton: {
    borderRadius: "8px",
    boxShadow: "0 4px 6px 0 rgba(68, 83, 226, 0.29)",
    backgroundColor: "#fe6439",
    fontFamily: "Poppins",
    fontSize: "14px",
    color: "#ffffff",
    textTransform: "none",

    "&:hover": {
        backgroundColor: "#fe6439",
    }
  },
}));
